
export const urlWithContour = () => {
  const url = window.location.origin
  const demo = url.includes('demo.') ? 'demo.' : ''
  const contour =
    url.includes('dev.')
    ? 'dev.' : url.includes('beta.')
    ? 'beta.' : url.includes('localhost')
    ? 'beta.' : ''
  return 'https://' + contour + demo + 'lfqr.cc'
}
